import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentPath: "",
    notificationToken: '',
    tokenCreated: false,
    notificationListenerInitialized: false,
    uiDisabled: false,
    /** Görüşmeye katıl tıklanınca hemen tam ekran yükleme (navigate öncesi/sonrası) */
    meetingJoinPending: false,
    receivedNotifications: [],
    /** Global bildirim detay modalı */
    activeNotification: null,
    /** Backend'den alınan bildirim ayarları; sayfa yüklenirken/ login sonrası set edilir, platform izinleri buna göre senkronize edilir */
    notificationSettings: {
        sendSMS: true,
        sendMail: true,
        sendAppNotification: true,
    },
}

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setCurrentPath: (state, { payload }) => {
            state.currentPath = payload
        },
        setUiDisabled: (state, { payload }) => {
            state.uiDisabled = payload
        },
        setMeetingJoinPending: (state, { payload }) => {
            state.meetingJoinPending = !!payload;
        },
        setNotificationToken: (state, { payload }) => {
            state.notificationToken = payload
        },
        setNotificationInitializer: (state, { payload }) => {
            state.notificationListenerInitialized = payload
        },
        clearApp: (state) => {
            state.currentPath = "";
            state.notificationToken = "";
            state.tokenCreated = false;
            state.notificationListenerInitialized = false;
            state.uiDisabled = false;
            state.meetingJoinPending = false;
            state.receivedNotifications = [];
            state.activeNotification = null;
            state.notificationSettings = { sendSMS: true, sendMail: true, sendAppNotification: true };
        },
        addNotification: (state, { payload }) => {
            if (state.receivedNotifications.filter(d => d.id === payload.id).length === 0)
                state.receivedNotifications = [...state.receivedNotifications, payload]
        },
        removeNotification: (state, { payload }) => {
            state.receivedNotifications = state.receivedNotifications.filter(d => d.id !== payload)
        },
        openNotificationModal: (state, { payload }) => {
            state.activeNotification = payload ?? null;
        },
        closeNotificationModal: (state) => {
            state.activeNotification = null;
        },
        patchActiveNotification: (state, { payload }) => {
            if (!state.activeNotification || !payload) return;
            state.activeNotification = { ...state.activeNotification, ...payload };
        },
        /** Mesaj odası açıldığında FCM vb. kuyruktaki bu odaya ait bildirimleri rozetden düşür */
        removeNotificationsForMessageRoom: (state, { payload: roomId }) => {
            if (roomId == null || roomId === "") return;
            const rid = String(roomId);
            state.receivedNotifications = state.receivedNotifications.filter(
                (n) => String(n?.data?.messageRoom ?? "") !== rid
            );
        },
        setNotificationSettings: (state, { payload }) => {
            if (payload && typeof payload === 'object') {
                if (typeof payload.sendSMS === 'boolean') state.notificationSettings.sendSMS = payload.sendSMS;
                if (typeof payload.sendMail === 'boolean') state.notificationSettings.sendMail = payload.sendMail;
                if (typeof payload.sendAppNotification === 'boolean') state.notificationSettings.sendAppNotification = payload.sendAppNotification;
            }
        },
    }
})


export const {
    setCurrentPath,
    setUiDisabled,
    setMeetingJoinPending,
    setNotificationInitializer,
    setNotificationToken,
    setNotificationSettings,
    addNotification,
    removeNotification,
    openNotificationModal,
    closeNotificationModal,
    patchActiveNotification,
    removeNotificationsForMessageRoom,
    clearApp
} = appSlice.actions;

export default appSlice.reducer;